import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Avatar } from '@hub/avatar';
import { UserMediumIcon } from '@hub/icon';
import { IconButton } from '@hub/button';
import { jsx as _jsx } from "react/jsx-runtime";
export const AccountPaneSmall = _ref => {
  let {
    name,
    avatarSrc,
    isLoggedIn,
    displayAccountNav,
    sx
  } = _ref;
  return isLoggedIn ? /*#__PURE__*/_jsx(IconButton, {
    icon: /*#__PURE__*/_jsx(Avatar, {
      name: name,
      src: avatarSrc,
      "data-id": "account-pane_small_AccountPaneSmall_Avatar"
    }),
    "aria-label": "View your account details",
    colorScheme: "white",
    size: "small",
    sx: _objectSpread(_objectSpread({}, sx), {}, {
      '&:hover': {
        color: 'quartz'
      },
      '&:active': {
        color: 'manatee'
      },
      '&:hover .chakra-avatar': {
        backgroundColor: 'quartz'
      },
      '&:active .chakra-avatar': {
        backgroundColor: 'manatee'
      }
    }),
    onClick: () => displayAccountNav(true),
    "data-id": "account-pane_small_AccountPaneSmall_IconButton"
  }) : /*#__PURE__*/_jsx(IconButton, {
    icon: /*#__PURE__*/_jsx(UserMediumIcon, {
      boxSize: "size-icon-md",
      "data-id": "account-pane_small_AccountPaneSmall_UserMediumIcon"
    }),
    "aria-label": 'Log into Membership',
    colorScheme: "white",
    size: "small",
    sx: _objectSpread(_objectSpread({}, sx), {}, {
      '&:hover': {
        color: 'quartz'
      },
      '&:active': {
        color: 'manatee'
      }
    }),
    onClick: () => displayAccountNav(true),
    "data-id": "account-pane_small_AccountPaneSmall_IconButton"
  });
};